const dateFields = [
  'birthdate_month_in',
  'birthdate_day_in'
];

export default (field) => {
  return dateFields.includes(field);
}
